module.exports = __webpack_public_path__ + "static/media/gaming12.c51eca29.webp";